import React from 'react';

export const CloudflareLogo: React.FC = () => {
  return (
    <div style={{ width: '100px', height: '100px', backgroundColor: '#f38020', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <span style={{ color: 'white', fontSize: '20px' }}>CF</span>
    </div>
  );
};
